import {
  buildWinterDoppelGroupScheduleIndex,
  generateWinterDoppelGroupDates,
  withWinterDoppelAlternatingGroupPhases,
} from "./groups.js";

function __asStr(v) {
  return String(v ?? "").trim();
}

export function trainingGroupSchedulesFromGroups(
  groups = [],
  seasonEnd = null,
) {
  const end = __asStr(seasonEnd);
  const phased = withWinterDoppelAlternatingGroupPhases(
    (Array.isArray(groups) ? groups : []).map((g) => ({
      ...g,
      schedule_end: g.schedule_end || g.scheduleEnd || end || null,
      season_end: end || g.season_end || null,
    })),
  );
  const withDates = phased.map((g) => ({
    ...g,
    dates: generateWinterDoppelGroupDates({
      ...g,
      exclude_holidays: false,
    }),
  }));
  return buildWinterDoppelGroupScheduleIndex(withDates);
}

export function expectedTrainingPlayerIdsForDate(groupSchedules, sessionDate) {
  const d = String(sessionDate || "").slice(0, 10);
  const ids = new Set();
  for (const gs of groupSchedules || []) {
    if (!gs?.dates?.has?.(d)) continue;
    for (const id of gs.playerIds || []) {
      const pid = __asStr(id);
      if (pid) ids.add(pid);
    }
  }
  return ids;
}

export function groupsPlayingTrainingDate(groupSchedules, sessionDate) {
  const d = String(sessionDate || "").slice(0, 10);
  return (groupSchedules || []).filter((gs) => gs?.dates?.has?.(d));
}

export function diffTrainingSessionPlayers(rows = [], expectedIds) {
  const expected =
    expectedIds instanceof Set
      ? expectedIds
      : new Set([...(expectedIds || [])].map(__asStr).filter(Boolean));
  const playing = (Array.isArray(rows) ? rows : []).filter(
    (sp) => __asStr(sp?.role) === "starter" && __asStr(sp?.rsvp) !== "no",
  );
  const present = new Set(playing.map((sp) => __asStr(sp.player_id)));
  return {
    keep: playing.filter((sp) => expected.has(__asStr(sp.player_id))),
    remove: playing.filter((sp) => !expected.has(__asStr(sp.player_id))),
    add: [...expected].filter((id) => !present.has(id)),
  };
}

function phaseBuckets(groups = []) {
  /** @type {Map<string, object[]>} */
  const buckets = new Map();
  for (const g of groups || []) {
    const wd = Number(g.weekday ?? g.weekDay);
    const iv = Math.max(1, Number(g.interval_weeks ?? g.intervalWeeks) || 1);
    if (!(wd >= 1 && wd <= 7) || iv < 2 || !g?.id) continue;
    const key = `${wd}|${iv}`;
    const arr = buckets.get(key) || [];
    arr.push(g);
    buckets.set(key, arr);
  }
  return buckets;
}

/**
 * Nächstes Terminpaar je 2-Wochen-Bucket für einmaligen Gruppentausch.
 * @returns {{ dateA: string, dateB: string }[]}
 */
export function nextWinterDoppelOneOffWeekSwapPairs(
  groups = [],
  fromDate = "",
) {
  const from = String(fromDate || "").slice(0, 10);
  const phased = withWinterDoppelAlternatingGroupPhases(groups);
  const pairs = [];
  for (const arr of phaseBuckets(phased).values()) {
    if (arr.length < 2) continue;
    const dates = new Set();
    for (const g of arr) {
      for (const d of generateWinterDoppelGroupDates({
        ...g,
        exclude_holidays: false,
      })) {
        if (!from || d >= from) dates.add(d);
      }
    }
    const sorted = [...dates].sort();
    if (sorted.length >= 2) {
      pairs.push({ dateA: sorted[0], dateB: sorted[1] });
    }
  }
  return pairs;
}
